import { render, staticRenderFns } from "./statistics-user.vue?vue&type=template&id=3f410c96&scoped=true&"
import script from "./statistics-user.vue?vue&type=script&lang=js&"
export * from "./statistics-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f410c96",
  null
  
)

export default component.exports